import { render, staticRenderFns } from "./SumPayments.vue?vue&type=template&id=450ece58&"
import script from "./SumPayments.vue?vue&type=script&lang=js&"
export * from "./SumPayments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports